import { useState } from 'react';
import { CanonicalContact, ContactRole } from '../helpers/contactShape';
import { SelectedContact } from './useContactPickerMultiOrchestrator';

export interface ContactPickerMultiUIState {
  searchTerm: string;
  selectedRoles: ContactRole[];
  selectedCategories: string[];
  selected: SelectedContact[];
  onChangeSearchTerm: (term: string) => void;
  onChangeSelectedRoles: (roles: ContactRole[]) => void;
  onChangeSelectedCategories: (categories: string[]) => void;
  onSelectContact: (contact: CanonicalContact) => void;
  onRemoveSelectedContact: (userId: string) => void;
}

const toSelectedContact = (contact: CanonicalContact): SelectedContact => {
  return {
    userId: contact.id,
    name: contact.fullName,
    role: contact.role,
    profileImage: contact.profileImage,
  };
};

export const useContactPickerMultiUIState = (
  initialSelected: SelectedContact[]
): ContactPickerMultiUIState => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [selectedRoles, setSelectedRoles] = useState<ContactRole[]>([]);
  const [selectedCategories, setSelectedCategories] = useState<string[]>([]);
  const [selected, setSelected] =
    useState<SelectedContact[]>(initialSelected);

  const onChangeSearchTerm = (term: string): void => {
    setSearchTerm(term);
  };

  const onChangeSelectedRoles = (roles: ContactRole[]): void => {
    setSelectedRoles(roles);
  };

  const onChangeSelectedCategories = (categories: string[]): void => {
    setSelectedCategories(categories);
  };

  const onSelectContact = (contact: CanonicalContact): void => {
    const alreadySelected: boolean = selected.some(
      (s: SelectedContact) => s.userId === contact.id
    );

    if (alreadySelected) {
      return;
    }

    setSelected((prev: SelectedContact[]) => [
      ...prev,
      toSelectedContact(contact),
    ]);
  };

  const onRemoveSelectedContact = (userId: string): void => {
    setSelected((prev: SelectedContact[]) =>
      prev.filter((s: SelectedContact) => s.userId !== userId)
    );
  };

  return {
    searchTerm,
    selectedRoles,
    selectedCategories,
    selected,
    onChangeSearchTerm,
    onChangeSelectedRoles,
    onChangeSelectedCategories,
    onSelectContact,
    onRemoveSelectedContact,
  };
};